import styled from 'styled-components'
import { BodyMedium, Title4 } from '../styles/Typography'
import { theme } from '../../theme/theme'
import { Info } from '../icons'
import { Popover } from '../Popover'
import { QuestionDescription } from '@estercare/ester-shared'

interface Props {
  title: string
  description?: QuestionDescription
}

export const ScreeningTitle = ({ title, description }: Props) => {
  const infoText = description?.infoText

  return (
    <Container>
      <Title4>{title}</Title4>
      {description && (
        <DescriptionWrapper $color={infoText ? theme.color.brightBlue : theme.color.grey5}>
          <StyledBodyMedium $isInfoText={!!infoText}>{description.text}</StyledBodyMedium>
          {infoText && (
            <Popover text={infoText}>
              <Info size={theme.fontSize.default} color={theme.color.brightBlue} />
            </Popover>
          )}
        </DescriptionWrapper>
      )}
    </Container>
  )
}

const Container = styled.div`
  & > * {
    text-align: left;
  }
`
const StyledBodyMedium = styled(BodyMedium)<{ $isInfoText: boolean }>`
  overflow: hidden;
`

const DescriptionWrapper = styled.div<{ $color: string }>`
  display: flex;
  flex-direction: row;
  align-items: center;
  margin-top: 6px;
  color: ${({ $color }) => $color};
  max-width: 600px;
  gap: ${theme.spacing.tiny}px;
  margin-left: ${theme.spacing.tiny}px;

  & > svg {
    cursor: pointer;
  }
`
